import { Link, NavLink, Outlet, useNavigate } from 'react-router-dom';
import Logo from '../Logo';
import { useAuth } from '../../context/AuthContext';

const tabs = [
  { to: '/sites', label: '网站列表', end: false },
  { to: '/api-settings', label: 'API设置', end: true },
  { to: '/account', label: '我的账号', end: true },
];

export default function ConsoleLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background-50">
      <header className="bg-background-50 border-b border-background-200">
        <div className="mx-auto max-w-6xl px-4 h-16 flex items-center justify-between">
          <Link to="/sites">
            <Logo />
          </Link>
          <div className="flex items-center gap-3 text-sm">
            <span className="w-8 h-8 rounded-full bg-accent-100 text-accent-800 flex items-center justify-center">
              <i className="ri-user-line" />
            </span>
            <span className="hidden sm:inline text-foreground-700">{user?.email}</span>
            <button
              type="button"
              onClick={() => {
                logout();
                navigate('/');
              }}
              className="text-foreground-500 hover:text-primary-600"
            >
              退出登录
            </button>
          </div>
        </div>
        <div className="mx-auto max-w-6xl px-4">
          <nav className="flex items-center gap-8">
            {tabs.map((tab) => (
              <NavLink
                key={tab.to}
                to={tab.to}
                end={tab.end}
                className={({ isActive }) =>
                  `relative py-3 text-sm font-semibold ${
                    isActive
                      ? 'text-foreground-950 after:absolute after:left-0 after:right-0 after:-bottom-px after:h-0.5 after:bg-accent-500'
                      : 'text-foreground-500 hover:text-foreground-800'
                  }`
                }
              >
                {tab.label}
              </NavLink>
            ))}
          </nav>
        </div>
      </header>
      <main className="mx-auto max-w-6xl px-4 py-6">
        <Outlet />
      </main>
    </div>
  );
}
